import { render, staticRenderFns } from "./ChangeMd.vue?vue&type=template&id=4defc3e8&scoped=true&"
import script from "./ChangeMd.vue?vue&type=script&lang=ts&"
export * from "./ChangeMd.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeMd.vue?vue&type=style&index=0&id=4defc3e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4defc3e8",
  null
  
)

export default component.exports